<template>
  <div>
    <div class="foot">
      <div class="all_box">
        <div class="foot_box">
          <div class="foot_left">
            <div class="foot_logo">
              <img src="@/assets/img/foot_logo.png">
            </div>
            <div class="foot_contact_item">
              <img src="@/assets/img/phone.png">0573-87763210
            </div>
            <div class="foot_contact_item">
              <img src="@/assets/img/email.png">jiangyb@baobobo.cn
            </div>
          </div>
          <div class="foot_right">
            <div class="foot_right_item">
              <ul class="foot_nav_one">
                <li>关于我们</li>
              </ul>
              <ul class="foot_nav_two">
                <li @click="navJump('About',1)">公司介绍</li>
                <li @click="navJump('About',2)">合作院校</li>
                <li @click="navJump('Programme')">社保方案</li>
                <li @click="navJump('NewList')">新闻动态</li>
                <li @click="navJump('Contact')">分支机构</li>
              </ul>
            </div>
            <div class="foot_right_item">
              <ul class="foot_nav_one">
                <li>企业服务</li>
              </ul>
              <ul class="foot_nav_two">
                <li @click="navJump('Serve',0)">劳务外包</li>
                <li @click="navJump('Serve',1)">人事代理</li>
                <li @click="navJump('Serve',2)">薪酬服务</li>
                <li @click="navJump('Serve',3)">劳务派遣</li>
                <li @click="navJump('Serve',4)">招聘服务</li>
                <li @click="navJump('Serve',5)">猎头服务</li>
                <li @click="navJump('Serve',6)">商务代理</li>
                <li @click="navJump('Serve',7)">法务帮助</li>
                <li @click="navJump('Serve',8)">商业保险</li>
                <li @click="navJump('Serve',9)">体检服务</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>



<script>
  export default {
    name: 'foots',
    props: {
      msg: String
    },
    methods: {
      navJump(item, type) {
        let routeName = this.$route.name
        if (routeName == item) {
          this.$emit('navChange', type)
        } else {
          debugger
          this.$router.push({
            name: item,
            params: {
              type
            }
          })
        }
      },
    },
  }
</script>



<style lang="scss" scoped>
  .foot {
    padding-top: 82px;
    background: linear-gradient(279.38deg, #F5F2F0 -1.72%, #F2F6F7 101.07%);
  }

  .foot_left {
    width: 35%;
  }

  .foot_right {
    .foot_right_item:first-child {
      margin-right: 170px;
    }
  }

  .foot_nav_two {
    li {
      margin-bottom: 20px;
      cursor: pointer;
    }
  }

  .foot_nav_one {
    font-size: 20px;
    color: #333;
    font-weight: 700;
    margin-right: 64px;

    li {
      border-bottom: 1px solid #333333;
      padding-bottom: 20px;
    }
  }

  .foot_right {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .foot_right_item {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .foot_logo {
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;
  }

  .foot_contact_item {
    text-align: left;
    font-size: 20px;
    color: #333;
    font-weight: 700;
    padding: 48px 0;
    border-bottom: 1px solid #eee;

    img {
      display: inline-block;
      margin-right: 28px;
      margin-bottom: -22px;
    }
  }

  .foot_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
</style>